var _defs, _g, _path, _path2, _path3, _path4, _path5, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSwipeH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 390 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 180,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9,
    y: -7,
    width: 408,
    height: 188,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_swipe_h") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,0H90a90,90,0,0,0,0,180H300A90,90,0,0,0,300,0",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.2,102.8l4.1-6c.3.2.6.5,1.1.9a14.37,14.37,0,0,0,2.7,1.5,9.52,9.52,0,0,0,3.8.9,4.75,4.75,0,0,0,2.4-.6,2.12,2.12,0,0,0,1-2,2.08,2.08,0,0,0-1.1-1.6,11.28,11.28,0,0,0-2.7-1.4c-1.1-.4-2.2-.9-3.5-1.5a29.13,29.13,0,0,1-3.5-2,8.38,8.38,0,0,1-2.7-2.9,8.21,8.21,0,0,1-1.1-4.2,8.77,8.77,0,0,1,3.3-7.1,12.37,12.37,0,0,1,8.1-2.7,16.86,16.86,0,0,1,5.6.9,11.83,11.83,0,0,1,3.6,1.8l1.1.9-3.3,6.4a11.49,11.49,0,0,0-1-.8,24.43,24.43,0,0,0-2.5-1.3,9.37,9.37,0,0,0-3.6-.8,4.75,4.75,0,0,0-2.4.6,2.06,2.06,0,0,0-1,1.9,2.28,2.28,0,0,0,1.5,1.9,30.82,30.82,0,0,0,3.6,1.7c1.4.5,2.8,1.2,4.3,1.9a10.64,10.64,0,0,1,3.6,3.1,8.14,8.14,0,0,1,1.5,4.9,9.19,9.19,0,0,1-3.1,7.1,11.64,11.64,0,0,1-8.3,2.9,18.41,18.41,0,0,1-4.1-.5,18.16,18.16,0,0,1-3.3-1.1c-.9-.5-1.7-.9-2.4-1.3a7,7,0,0,1-1.5-1.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.7,106.9l-7.8-32.2h8.3l4,20.1c.1.6.2,1.2.3,1.7a6.82,6.82,0,0,1,.1,1.2v.4h.1a16.39,16.39,0,0,1,.5-3.4l4.9-20.1h6.3l4.8,20.1c.1.6.3,1.2.4,1.7a7.07,7.07,0,0,0,.2,1.2V98h.1a15.46,15.46,0,0,1,.4-3.4l4.4-20.1h8.1l-8.1,32.2H177l-4-16.2-.6-3.8h-.1a32.62,32.62,0,0,1-.6,3.8l-4,16.2h-9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.6,106.9V74.7h7.9v32.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214,106.9V74.7h13.4a10,10,0,0,1,7.6,3.1,12.48,12.48,0,0,1,0,16,9.81,9.81,0,0,1-7.6,3.1h-5.5v9.9H214Zm7.9-16.7h3.9a3.77,3.77,0,0,0,3-1.2,4.77,4.77,0,0,0,1.1-3.2,4.29,4.29,0,0,0-1-3.1,4.07,4.07,0,0,0-2.9-1.2h-4v8.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.5,106.9V74.7h20.2v6.8H250.4v5.8h9.8v6.8h-9.8v6.1h12.9V107H242.5Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,104.5a2.73,2.73,0,0,1,.8-1.9L313.4,90,300.8,77.4a2.76,2.76,0,0,1,3.9-3.9L319.2,88a2.72,2.72,0,0,1,0,3.9l-14.5,14.5a2.75,2.75,0,0,1-4.7-1.9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90,75.5a2.73,2.73,0,0,1-.8,1.9L76.6,90l12.6,12.6a2.76,2.76,0,0,1-3.9,3.9L70.8,92a2.72,2.72,0,0,1,0-3.9L85.3,73.6A2.75,2.75,0,0,1,90,75.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwipeH);
export default __webpack_public_path__ + "static/media/ic_swipe_h.874583aaa34fa79da912cfb2139a363c.svg";
export { ForwardRef as ReactComponent };